define('shared/initializer/form/adapters/mixins/ReCaptcha',[
    '$',
    'shared/lib/RSVP',
    '../../constants'
], function(
    $,
    RSVP,
    constants
){
    function Ctor() { }
    var SITE_KEY = "6Lc9x-oUAAAAADB6JXGce4Xf1gz5HcAnY9kgLl3K";
    var CAPTCHA_STYLE = "display:inline-flex;justify-content:center;width:100%;margin-top:20px;margin-bottom:20px;";

    Ctor.prototype.doPageLoad = function () {
        var me = this;
        // if me.options.captchaType is undefined this still activates as it is default
        if (me.options.captchaType && (me.options.captchaType !== "recaptcha")) {
            return RSVP.resolve();
        }


        // Insert the dom element recaptcha expects into our form
        me.$form.append(
            '<div class="g-recaptcha" data-sitekey="'
            + SITE_KEY 
            + '" style="'
            + CAPTCHA_STYLE
            + '"></div><br />'
        );

        // Load google third party script it will take SITE_KEY from dom element
        var captchaScript = document.createElement("script");
        captchaScript.type = "text/javascript";
        captchaScript.src = "https://www.recaptcha.net/recaptcha/api.js";
        me.$form.append(captchaScript);

        return RSVP.resolve();
    };

    Ctor.prototype.doBeforeSubmit = function(){
        var me = this;
        if (me.options.captchaType && (me.options.captchaType !== "recaptcha")) {
            return RSVP.resolve();
        }

        var CAPTCHA_NOT_COMPLETED_ERROR = me.options.captchaNotCompleted !== 'el.login.captcha' ? me.options.captchaNotCompleted : 'Fill in captcha';

        if (window.grecaptcha) {
            var res = window.grecaptcha.getResponse();
            if (res.length === 0) {
                var err = new Error(CAPTCHA_NOT_COMPLETED_ERROR);
                err.fatal = false;
                err.type = 'captchaNotCompleted';
                return RSVP.reject(err);
            }
        }
        return RSVP.resolve();
    };


    return Ctor;
});
